import React, { Fragment, useEffect, useState } from "react";
import { Row, Col, Card, CardBody, CustomInput, Button } from "reactstrap";
import Loader from "react-loaders";
import { api } from "../../_services/api.service";
import { userService } from "../../_services/user.service";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import AvField from "availity-reactstrap-validation/lib/AvField";
import { toast } from "react-toastify";
import swal from "sweetalert";

const ParticipantSettings = (props) => {
  const currentUser = userService.getLoggedInUser();
  const partnerScenarioId = parseInt(props.match.params.partnerScenarioId);
  const partnerId = parseInt(props.match.params.scenarioId);
  let participantId = parseInt(props.match.params.participantId);

  let [participant, setParticipant] = useState({
    participantID: -1,
    firstName: "",
    lastName: "",
    email: "",
    inactive: false,
    partnerID: partnerId,
    partnerScenarioID: partnerScenarioId,
  });
  let [isLoading, setIsLoading] = useState(false);

  const successToastOpts = {
    autoClose: 3000,
    type: toast.TYPE.SUCCESS,
    hideProgressBar: false,
  };

  useEffect(() => {
    loadParticipant(participantId);
  }, []);

  const loadParticipant = (id) => {
    if (id > 0) {
      setIsLoading(true);
      api.getParticipantById(id).then((data) => {
        setParticipant(data);
        setIsLoading(false);
      });
    }
  };

  const handleSubmit = (e, errors, values) => {
    if (errors.length == 0) {
      if (participant.participantID > 0) {
        api.updateParticipant(currentUser.userID, participant).then((data) => {
          toast("Participant saved successfuly", successToastOpts);
          //props.history.goBack();
        });
      } else {
        let obj = { ...participant };
        obj.user = {};
        obj.user.firstName = participant.firstName;
        obj.user.lastName = participant.lastName;
        obj.user.email = participant.email;
        api
          .createParticipant(currentUser.userID, partnerScenarioId, obj)
          .then((id) => {
            toast("Participant saved successfuly", successToastOpts);

            //props.history.goBack();
            props.history.replace({
              pathname: `/participant/${partnerId}/${partnerScenarioId}/${id}`,
            });
            // partnerMetricId = id;
            // loadMetric(id);
          });
      }
    }
  };

  const removeParticipant = () => {
    swal({
      text: "Are you sure you want to remove this participant?",
      icon: "warning",
      buttons: {
        ok: "Yes",
        cancel: "No",
      },
      dangerMode: true,
    }).then((val) => {
      if (val) {
        api.deleteParticipant(0, participant).then((data) => {
          props.history.goBack();
        });
      }
    });
  };

  return (
    <Fragment>
      {isLoading && <Loader style={{}} type="ball-pulse" active />}
      {!isLoading && (
        <Row style={{ marginTop: "30px" }}>
          <Col md="6">
            <Card className="main-card mb-3">
              <CardBody>
                <AvForm onSubmit={handleSubmit}>
                  <Row>
                    <Col md="12">
                      <AvField
                        name="firstName"
                        label="First Name *"
                        value={participant.firstName}
                        onChange={(e) =>
                          setParticipant({
                            ...participant,
                            firstName: e.target.value,
                          })
                        }
                        placeholder="Enter..."
                        required
                      />
                      <AvField
                        name="lastName"
                        label="Last Name *"
                        value={participant.lastName}
                        onChange={(e) =>
                          setParticipant({
                            ...participant,
                            lastName: e.target.value,
                          })
                        }
                        placeholder="Enter..."
                        required
                      />
                      <AvField
                        name="email"
                        label="Email *"
                        value={participant.email}
                        onChange={(e) =>
                          setParticipant({
                            ...participant,
                            email: e.target.value,
                          })
                        }
                        placeholder="Enter..."
                        required
                      />
                    </Col>
                  </Row>
                  <div className="pull-right">
                    <Button
                      color="primary"
                      type="submit"
                      style={{ marginRight: ".25rem" }}
                    >
                      Save
                    </Button>
                    {participant.participantID > 0 && (
                      <Button
                        color="danger"
                        onClick={() => removeParticipant()}
                      >
                        Delete
                      </Button>
                    )}
                    <Button
                      color="link"
                      className="pull-right"
                      onClick={() => props.history.goBack()}
                    >
                      Cancel
                    </Button>
                  </div>
                </AvForm>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </Fragment>
  );
};

export default ParticipantSettings;
